import React from "react";
import PetroleumGasoline from "./PetroleumGasoline";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const Petrol = () => {
  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Stationary Combustion">
        <PetroleumGasoline />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Petrol;
